<template>
  <div v-if="isSubSocialLogin.length && isSubSocialLogin != ''">
    <template v-for="(socialLogins, i) in isSubSocialLogin">
      <a
        href="javascript:;"
        @click="authenticate(socialLogins.label.toLowerCase())"
        class="mx-20"
        :key="i"
        v-if="socialLogins.value.status"
      >
        <img :src="mediaIcons[socialLogins.label]" :alt="socialLogins.label" />
      </a>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "SocialAuth",
  props: {
    returnTo: {
      type: String,
      default: null
    }
  },
  methods: {
    authenticate(provider) {
      const cb = encodeURIComponent(process.env.VUE_APP_URL + "/auth/callback");
      const returnTo = this.returnTo || location.pathname;
      const url =
        process.env.VUE_APP_API +
        `/auth/${provider}?callback_url=${cb}&return_to=${returnTo}`;

      window.open(url, "_self");
    }
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "sociallogin");

    let filter = {
      key: "sociallogin.sub"
    };
    this.isSubSocialLogin = _.filter(this.options, filter);
  },
  data: () => ({
    isSubSocialLogin: {},
    mediaIcons: {
      Facebook: require("@/assets/media/icons/social/icon-fb-box.png"),
      LinkedIn: require("@/assets/media/icons/social/icon-linkedin-box.png"),
      Google: require("@/assets/media/icons/social/icon-google-box.png")
    }
  })
};
</script>

<style lang="scss"></style>
